// One content node serves inline, accordion and the existing shared modal shell.
if (!customElements.get('aplovio-information')) {
  const instances = new Set();
  const rowGroups = new Map();
  function alignRows(group) {
    const vertical=getComputedStyle(group).flexDirection==='column';let previous=null;
    for(const child of group.children) {
      if(child.hidden || getComputedStyle(child).display==='none')continue;
      const information=child.matches('.ap-information-view');
      if(information)child.toggleAttribute('data-information-joined',vertical && !!previous?.matches('.ap-information-view'));
      previous=child;
    }
  }
  function watchRows(group) {
    if(!group?.matches('.ap-product-column,.ap-product-group'))return null;
    let entry=rowGroups.get(group);
    if(!entry){const observer=new MutationObserver(()=>alignRows(group));observer.observe(group,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden','data-direction']});entry={observer,count:0};rowGroups.set(group,entry);}
    entry.count++;alignRows(group);return group;
  }
  let selectedEditorBlock = null;
  const editorKey = node => {
    try {return JSON.parse(node.parentElement.getAttribute('data-shopify-editor-block')).id;}
    catch {return node.dataset.blockId;}
  };
  document.addEventListener('shopify:block:select', event => {
    const node=event.target.closest?.('.ap-information-view')?.querySelector('aplovio-information');
    selectedEditorBlock=node?.hasAttribute('data-design-mode')?editorKey(node):null;
  },true);
  document.addEventListener('shopify:block:deselect', event => {
    const node=event.target.closest?.('.ap-information-view')?.querySelector('aplovio-information');
    if(node && selectedEditorBlock===editorKey(node))selectedEditorBlock=null;
  },true);
  class AplovioInformation extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const lifetime = this.abort;
      queueMicrotask(() => {if (this.isConnected && this.abort === lifetime) this.setup();});
    }
    setup() {
      this.details = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      this.heading = this.querySelector('[data-information-heading]');
      this.content = this.querySelector('[data-information-content]');
      this.home = this.querySelector('[data-information-home]');
      this.layer = this.querySelector('aplovio-layer');
      this.dialog = this.layer?.querySelector('dialog');
      this.panelSlot = this.querySelector('[data-information-panel-slot]');
      if (!this.details || !this.dialog) return;
      instances.add(this);
      this.expanded = this.dataset.initialOpen === 'true';
      this.media = matchMedia('(max-width:989px)');
      this.reduceMotion=matchMedia('(prefers-reduced-motion:reduce)');
      this.rowGroup=watchRows(this.parentElement.parentElement);
      const options = {signal:this.abort.signal};
      this.media.addEventListener('change', () => this.configure(), options);
      this.reduceMotion.addEventListener('change',()=>{if(this.reduceMotion.matches)this.setExpanded(this.expanded,false);},options);
      this.trigger.addEventListener('click', event => {
        if (this.mode === 'panel' && window.AplovioLayers && typeof this.layer.open === 'function') {
          event.preventDefault();
          if (!window.AplovioLayers.top()) this.layer.open(this.trigger);
        } else if (this.mode === 'accordion') {
          event.preventDefault();this.setExpanded(!this.expanded);
        }
      }, options);
      this.details.addEventListener('toggle', () => {
        if (this.mode !== 'accordion' || this.disclosureAnimation) return;
        this.expanded = this.details.open;
        this.trigger.setAttribute('aria-expanded',String(this.expanded));
        if (this.expanded) this.closePeers();
      }, options);
      this.dialog.addEventListener('aplovio:layer-open', () => {
        // History can reopen the shared shell directly after a viewport change.
        if (this.mode !== 'panel') {window.AplovioLayers.close(this.dialog,'disconnect',true);return;}
        window.AplovioLazy.mount(this.content);
        this.panelSlot.append(this.content);
        this.trigger.setAttribute('aria-expanded','true');
      }, options);
      this.dialog.addEventListener('aplovio:layer-close', () => {
        this.home.append(this.content);
        if(this.mode === 'panel') this.trigger.setAttribute('aria-expanded','false');
        else this.trigger.removeAttribute('aria-expanded');
        if(this.mode === 'inline' && this.isConnected && !window.AplovioLayers.top()) {
          this.heading.tabIndex=-1;this.heading.focus({preventScroll:true});
        }
      }, options);
      if (this.hasAttribute('data-design-mode')) {
        document.addEventListener('shopify:block:select', event => {
          if (!this.selectedBy(event)) return;
          selectedEditorBlock=editorKey(this);this.revealEditor();
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          if (!this.selectedBy(event)) return;
          if (this.dialog.open) this.layer.close('editor');
        }, options);
      }
      this.configure();
      if(this.hasAttribute('data-design-mode') && selectedEditorBlock===editorKey(this))this.revealEditor();
    }
    revealEditor() {
      if (this.mode === 'panel') {
        const current = window.AplovioLayers?.top();
        if (current && current !== this.dialog) window.AplovioLayers.close(current,'disconnect',true);
        this.layer.open?.(this.trigger);
      } else if (this.mode === 'accordion') this.setExpanded(true,false);
    }
    selectedBy(event) {
      return event.detail?.blockId === this.dataset.blockId || event.target === this || event.target.closest?.('.ap-information-view') === this.parentElement;
    }
    setGroupMode(mode) {
      this.groupMode = mode;
      if (this.details && this.mode !== mode) this.configure();
    }
    configure() {
      this.cancelDisclosure();
      let mode = this.media.matches && this.dataset.mobile !== 'same' ? this.dataset.mobile : this.dataset.desktop;
      if (this.groupMode) mode = this.groupMode;
      if (!['inline','accordion','panel'].includes(mode)) mode='accordion';
      this.mode = mode;
      if (mode !== 'panel') window.AplovioLazy.mount(this.content);
      this.dataset.mode = mode;
      this.heading.hidden = mode !== 'inline';
      this.trigger.hidden = mode === 'inline';
      this.details.open = mode === 'inline' || mode === 'accordion' && this.expanded;
      if (mode === 'panel') {
        this.trigger.setAttribute('aria-haspopup','dialog');
        this.trigger.setAttribute('aria-controls',this.dialog.id);
        this.trigger.setAttribute('aria-expanded',String(this.dialog.open));
      } else {
        this.trigger.removeAttribute('aria-haspopup');
        this.trigger.removeAttribute('aria-controls');
        if(mode==='accordion')this.trigger.setAttribute('aria-expanded',String(this.expanded));
        else this.trigger.removeAttribute('aria-expanded');
        if (this.dialog.open) this.layer.close('presentation');
        else this.home.append(this.content);
      }
      if (mode === 'accordion' && this.expanded) this.closePeers(false);
      if(this.rowGroup)alignRows(this.rowGroup);
    }
    cancelDisclosure() {
      this.disclosureAnimation=null;
      if(this.details)window.AplovioLayers?.cancelDisclosure(this.details);
      this.removeAttribute('data-information-animating');
      if(this.home)this.home.inert=false;
    }
    setExpanded(expanded,animate=true) {
      if(this.mode!=='accordion')return;
      if(this.expanded===expanded && this.details.open===expanded && !this.disclosureAnimation)return;
      this.expanded=expanded;
      if(expanded)this.closePeers(animate);
      this.dataset.informationAnimating=expanded?'opening':'closing';
      this.disclosureAnimation=window.AplovioLayers.disclose(this.details,this.home,expanded,{animate,onFinish:()=>{this.disclosureAnimation=null;this.removeAttribute('data-information-animating');}});
    }

    closePeers(animate=true) {
      const group = this.closest('[data-information-group]');
      if (group?.dataset.informationExclusive !== 'true') return;
      for (const peer of instances) if (peer !== this && peer.mode === 'accordion' && peer.closest('[data-information-group]') === group) {
        peer.setExpanded(false,animate);
      }
    }
    disconnectedCallback() {
      this.abort?.abort();this.abort=null;
      this.cancelDisclosure();
      instances.delete(this);
      if(this.rowGroup){const entry=rowGroups.get(this.rowGroup);if(entry && --entry.count===0){entry.observer.disconnect();rowGroups.delete(this.rowGroup);}else alignRows(this.rowGroup);this.rowGroup=null;}
      if (this.dialog) window.AplovioLayers?.dispose(this.dialog);
      if (this.home && this.content) this.home.append(this.content);
    }
  }
  customElements.define('aplovio-information', AplovioInformation);
}
